// Vendors
import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

const ClearSearch = ({ items, refine }) => (
  <button
    className="btn btn--blue btn--lg"
    onClick={() => refine(items)}
    disabled={!items.length}
  >
    <span className="btn__content">
      <span className="btn__text">Reset Search</span>
    </span>
  </button>
);

export default connectCurrentRefinements(ClearSearch);
